import { render } from "./AddEditpbMajorSchool.vue?vue&type=template&id=647e0e00&scoped=true"
import script from "./AddEditpbMajorSchool.vue?vue&type=script&lang=js"
export * from "./AddEditpbMajorSchool.vue?vue&type=script&lang=js"

import "./AddEditpbMajorSchool.vue?vue&type=style&index=0&id=647e0e00&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647e0e00"]])

export default __exports__